export default {
	SettingSystem: function(state) {
		return state.SettingSystem;
	}
};
